<script>
	import { onMount } from 'svelte';
	import { dadosUsuarioLS } from '../../utils';
	import Painel from './Painel.svelte';

	const opcoes = [
		{ 
			titulo: "Voltar", 
			icone: "voltar",
			link: "#/painel",
			perfis: "CETREINA,AVALIADOR,DISCENTE,COORDENADOR"
		},
		{ 
			titulo: "Meu Cadastro", 
			icone: "usuario",
			perfis: "CETREINA,AVALIADOR,DISCENTE,COORDENADOR"
		},
		{ 
			titulo: "Listar", 
			icone: "listar",
			link: "#/usuario/listagem",
			perfis: "CETREINA"		
		},
		{ 
			titulo: "Buscar", 
			icone: "buscar",
			link: "#/busca/formulario/usuario",
			perfis: "CETREINA"	
		}
	];
	
	onMount(async () => {
		const dadosUsuario = dadosUsuarioLS();
		
		if (dadosUsuario) {
			let meuCadastro = opcoes.filter(item => {
				return item.titulo == "Meu Cadastro";
			});
				
			meuCadastro = meuCadastro[0];
			meuCadastro.link = `#/usuario/visualizar/${dadosUsuario.cpf}`;
		}
	});	
</script>

<Painel 
	titulo="Painel de Usuários" 
	listaFuncionalidades={opcoes}>
</Painel>